import { Instrument, InstrumentType } from "../types/Instrument";
import { getData } from "./apiService";

// Fetch all instruments
export const getAllInstruments = async (): Promise<Instrument[]> => {
    try {
      const response = await getData('/instruments/all', {});
      return response.data as Instrument[];
    } catch (error) {
      console.error('Failed to fetch instruments:', error);
      return [];
    }
  };
  
  // Fetch standard concert band instruments
  export const getStandardConcertBandInstruments = async (): Promise<Instrument[]> => {
    try {
      const response = await getData('/instruments/concert-band', {});
      return response.data as Instrument[];
    } catch (error) {
      console.error('Failed to fetch concert band instruments:', error);
      return [];
    }
  };
  
  // Fetch all concert band instruments
  export const getAllConcertBandInstruments = async (): Promise<Instrument[]> => {
    try {
      const response = await getData('/instruments/concert-band/all', {});
      return response.data as Instrument[];
    } catch (error) {
      console.error('Failed to fetch all concert band instruments:', error);
      return [];
    }
  };
  
  // Fetch standard orchestra instruments
  export const getStandardOrchestraInstruments = async (): Promise<Instrument[]> => {
    try {
      const response = await getData('/instruments/orchestra', {});
      return response.data as Instrument[];
    } catch (error) {
      console.error('Failed to fetch orchestra instruments:', error);
      return [];
    }
  };
  
  // Fetch all orchestra instruments
  export const getAllOrchestraInstruments = async (): Promise<Instrument[]> => {
    try {
      const response = await getData('/instruments/orchestra/all', {});
      return response.data as Instrument[];
    } catch (error) {
      console.error('Failed to fetch all orchestra instruments:', error);
      return [];
    }
  };
  
  // Fetch standard jazz band instruments
  export const getStandardJazzBandInstruments = async (): Promise<Instrument[]> => {
    try {
      const response = await getData('/instruments/jazz-band', {});
      return response.data as Instrument[];
    } catch (error) {
      console.error('Failed to fetch jazz band instruments:', error);
      return [];
    }
  };
  
  // Fetch all jazz band instruments
  export const getAllJazzBandInstruments = async (): Promise<Instrument[]> => {
    try {
      const response = await getData('/instruments/jazz-band/all', {});
      return response.data as Instrument[];
    } catch (error) {
      console.error('Failed to fetch all jazz band instruments:', error);
      return [];
    }
  };
  
  // Fetch standard marching band instruments
  export const getStandardMarchingBandInstruments = async (): Promise<Instrument[]> => {
    try {
      const response = await getData('/instruments/marching-band', {});
      return response.data as Instrument[];
    } catch (error) {
      console.error('Failed to fetch marching band instruments:', error);
      return [];
    }
  };
  
  // Fetch all marching band instruments
  export const getAllMarchingBandInstruments = async (): Promise<Instrument[]> => {
    try {
      const response = await getData('/instruments/marching-band/all', {});
      return response.data as Instrument[];
    } catch (error) {
      console.error('Failed to fetch all marching band instruments:', error);
      return [];
    }
  };
  
  // Fetch choir instruments
  export const getChoirInstruments = async (): Promise<Instrument[]> => {
    try {
      const response = await getData('/instruments/choir', {});
      return response.data as Instrument[];
    } catch (error) {
      console.error('Failed to fetch choir instruments:', error);
      return [];
    }
  };
  
  // Fetch string instruments
  export const getStringInstruments = async (): Promise<Instrument[]> => {
    try {
      const response = await getData('/instruments/strings', {});
      return response.data as Instrument[];
    } catch (error) {
      console.error('Failed to fetch string instruments:', error);
      return [];
    }
  };
  
  // Fetch instrument types
  export const getInstrumentTypes = async (): Promise<InstrumentType[]> => {
    try {
      const response = await getData('/instruments/types', {});
      return response.data as InstrumentType[];
    } catch (error) {
      console.error('Failed to fetch instrument types:', error);
      return [];
    }
  };
  